import { render, staticRenderFns } from "./sent.vue?vue&type=template&id=70ea20d8&"
import script from "./sent.js?vue&type=script&lang=js&"
export * from "./sent.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports